export default [
    // 'extencion',
    
    {
        model_name: 'bodega',
        if_has_extencion: 'vinoteca',
    },
    {
        model_name: 'cepa',
        if_has_extencion: 'vinoteca',
    },

    'sale_channel',
    'meli_listing_type',
    'meli_buying_mode',
    'meli_item_condition',
    'article_ubication',
    'online_template',
    'pais_exportacion',
    'moneda',
    'address',
    'client',
    'provider',
    'column_position',
    'current_acount_payment_method',
    'afip_tipo_comprobante',
    'afip_information',
    'concepto_stock_movement',
    'category_price_type_range',
    'article_price_type_group',
    'provider_order_status',
    'category',
    'order_status',
    'tienda_nube_order_status',
    'current_acount_payment_method_discount',
    'default_payment_method_caja',
    'order_production_status',
    'deposit_movement_status',
    'budget_status',
    'cuota',
    'concepto_movimiento_caja',
    'caja',
    'tipo_envase',
    'article',
    'unidad_frecuencia',
    'afip_selected_payment_method',
    'expense_concept',
    'expense_category',
    'article_pre_import_range',
    'price_type',
    'unidad_medida',
    'article_property_type',
    'article_property_value',
    // 'task',
    'employee',
    'permission',
    'sale_type',
    'discount',
    'surchage',
    'brand',
    'condition',
    'recipe',
    'iva',
    'iva_condition',
    'sub_category',
    'provincia',
    'location',
    'seller',
    'payment_method',
    'payment_method_type',
    // 'commission',
    'commission',
    'delivery_day',
    'delivery_zone',
    'sale',
    // 'credit_card',
    // 'credit_card_payment_plan',
    'order',
    'online_price_type',
    // 'buyer',
    'inventory_linkage_scope',
    'article_ticket_info',
    'client_reputation',
]